import { Container, Row, Col } from "react-bootstrap";
import heroImg from "../components/images/ranchWeddingImages/pastureMountain.jpg";
import '../assets/css/about.css';

export default function About() {
  return (
    <>
      <div className="about-hero">
        <img className="about-hero-img" src={heroImg} alt="Cascade Mountain Ranch grounds" />
        <div className="about-hero-overlay">
          <p className="about-hero-eyebrow">Hugo, Oregon</p>
          <h1>About</h1>
          <p className="about-hero-sub">Cascade Mountain Ranch</p>
        </div>
      </div>

      <div className="about-intro">
        <div className="about-intro-inner">
          <div className="about-accent-line"></div>
          <p>
            Cascade Mountain Ranch offers the perfect setting for your next big event. Our private
            50 acre ranch includes both open valley and mountain foothills, perfect for showing off
            the best nature has to offer. The ranch is surrounded by rich forest land that serves as
            home to an array of wildlife. Seasonal creeks run through the property into our two
            lakes where you will find fish, ducks, and geese.
          </p>
          <p>
            Our upper lake event deck features an on-site kitchen, perfect for receptions, while our
            island gazebo is situated on our secluded lower lake. You can enjoy all of this natural
            beauty from the comfort of our two cozy mountain lodges, which each sleep up to 30
            guests and provide picturesque mountain views.
          </p>
          <p className="about-intro-tagline">
            The perfect location for your wedding, reunion, or retreat.
          </p>
          <a className="about-intro-btn" href="/contact">Schedule a Tour</a>
          <p className="about-invite">We look forward to serving you.</p>
        </div>
      </div>

      <div className="about-directions">
        <Container>
          <h2 className="about-directions-title">Directions</h2>
          <div className="about-directions-line"></div>
          <Row>
            <Col className="about-directions-col" xl={6}>
              <h4>Coming from the North</h4>
              <p>Head south on I-5.</p>
              <p>Take exit 66 toward Hugo. Go .3 mi.</p>
              <p>Turn LEFT onto Monument Dr. Go for .3 mi.</p>
              <p>Turn RIGHT onto Jump-Off Joe Creek Rd. Go 1.9 mi.</p>
              <p>Your destination will be on your LEFT.</p>
            </Col>
            <Col className="about-directions-col" xl={6}>
              <h4>Coming from the South</h4>
              <p>Head north on I-5.</p>
              <p>Take exit 66 toward Hugo. Go .3 mi.</p>
              <p>Turn LEFT onto Monument Dr. Go for .3 mi.</p>
              <p>Turn RIGHT onto Jump-Off Joe Creek Rd. Go 1.9 mi.</p>
              <p>Your destination will be on your LEFT.</p>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="about-map">
        <iframe
          title="Cascade Mountain Ranch Map"
          src="//www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2937.9820332572726!2d-123.33890028446842!3d42.576903829372306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54c59e2df6da1719%3A0xca312100026e0002!2s2500%20Jumpoff%20Joe%20Creek%20Rd%2C%20Grants%20Pass%2C%20OR%2097526!5e0!3m2!1sen!2sus!4v1667513044396!5m2!1sen!2sus"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </>
  );
}
